import PrivateRoute from 'components/PrivateRoute';
import React from 'react';
import { Switch } from 'react-router';
import CriterionClassDisciplineListPage from './pages/CriterionClassDisciplineListPage';
import CriterionClassDisciplineFormPage from './pages/CriterionClassDisciplineFormPage';

export default () => (
  <Switch>
    <PrivateRoute
      exact
      path="/criterios-turma-disciplina"
      permission="activities.view_criterionclassdiscipline"
      component={CriterionClassDisciplineListPage}
    />
    <PrivateRoute
      exact
      path="/criterios-turma-disciplina/:id/edit"
      permission="activities.change_criterionclassdiscipline"
      component={CriterionClassDisciplineFormPage}
    />
    <PrivateRoute
      exact
      path="/criterios-turma-disciplina/new"
      permission="activities.add_criterionclassdiscipline"
      component={CriterionClassDisciplineFormPage}
    />
  </Switch>
);
